import BottomNavCodit from './BottomNavCodit';

export default BottomNavCodit;
